import { NgModule } from '@angular/core';
import { AppRoutesName } from '../../const/AppRoutesName';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.FR.DASHBOARD_INDEX,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.DASHBOARD_INDEX,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },

  {
    path: ':shop_uuid/' + AppRoutesName.FR.DASHBOARD_INDEX1,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.DASHBOARD_INDEX1,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },

  {
    path: ':shop_uuid/' + AppRoutesName.FR.DASHBOARD_INDEX2,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.DASHBOARD_INDEX2,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },

  {
    path: ':shop_uuid/' + AppRoutesName.FR.DASHBOARD_INDEX3,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.DASHBOARD_INDEX3,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },

  {
    path: ':shop_uuid/' + AppRoutesName.FR.DASHBOARD_INDEX4,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.DASHBOARD_INDEX4,
    loadComponent: () =>
      import('./dashboard-index.component').then(
        (m) => m.DashboardIndexComponent,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardIndexModule {}
